import { AdminShell } from "@project/admin/components/admin-shell";
import { ApiResourceTable } from "@project/admin/components/api-resource-table";
import type { Field } from "@project/admin/components/resource-table";
import { trusteeService } from "@project/services/admin/trustee.service";
import type { Trustee, TrusteePayload } from "@project/types/trustee";

const fields: Field[] = [
  {
    name: "name",
    label: "Full Name",
    required: true,
    showInTable: true,
    placeholder: "Ramesh Patel",
  },
  {
    name: "designation",
    label: "Designation",
    showInTable: true,
    placeholder: "Chairman",
  },
  {
    name: "mobile",
    label: "Mobile",
    type: "tel",
    showInTable: true,
    placeholder: "9876543210",
  },
  {
    name: "email",
    label: "Email",
    type: "email",
    showInTable: true,
    placeholder: "ramesh@example.com",
  },
  {
    name: "order_by",
    label: "Order By",
    type: "number",
    showInTable: true,
    placeholder: "0",
  },
  {
    name: "is_enabled",
    label: "Active",
    type: "boolean",
    showInTable: true,
  },
];

function toPayload(payload: Record<string, unknown>): TrusteePayload {
  return {
    name: String(payload.name ?? "").trim(),
    designation: payload.designation
      ? String(payload.designation).trim()
      : undefined,
    mobile: payload.mobile ? String(payload.mobile).trim() : undefined,
    email: payload.email ? String(payload.email).trim() : undefined,
    is_enabled: payload.is_enabled === true || payload.is_enabled === "true",
    order_by:
      payload.order_by !== undefined && payload.order_by !== ""
        ? Number(payload.order_by)
        : 0,
  };
}

export default function Page() {
  return (
    <AdminShell title="Trustees" subtitle="Board of trustees">
      <ApiResourceTable<Trustee>
        title="Trustee"
        labelField="name"
        fields={fields}
        searchFields={["name", "designation", "mobile"]}
        defaultValues={{ is_enabled: true, order_by: 0 }}
        enableCsvExport
        csvFileName="trustees"
        list={query => trusteeService.listTrusteesPage(query)}
        create={payload => trusteeService.createTrustee(toPayload(payload))}
        update={(id, payload) =>
          trusteeService.updateTrustee(id, toPayload(payload))
        }
        remove={id => trusteeService.deleteTrustee(id)}
      />
    </AdminShell>
  );
}
